<template>
  <div class="progress-ring" :style="{ width: size + 'px', height: size + 'px' }">
    <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" role="img" :aria-label="`${displayPercent}% complete`">
      <circle
        class="progress-ring-track"
        :cx="center"
        :cy="center"
        :r="radius"
        fill="none"
        :stroke-width="strokeWidth"
      />
      <circle
        class="progress-ring-fill"
        :cx="center"
        :cy="center"
        :r="radius"
        fill="none"
        :stroke="color"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
        :transform="`rotate(-90 ${center} ${center})`"
      />
    </svg>
    <div class="progress-ring-label" v-if="showLabel">
      <span class="progress-ring-value">{{ displayPercent }}<span class="progress-ring-pct">%</span></span>
      <span v-if="sublabel" class="progress-ring-sublabel">{{ sublabel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressRing",
  props: {
    percent: { type: Number, default: 0 },
    size: { type: Number, default: 120 },
    strokeWidth: { type: Number, default: 10 },
    color: { type: String, default: "#1565C0" },
    showLabel: { type: Boolean, default: true },
    sublabel: { type: String, default: "" },
  },
  computed: {
    center() {
      return this.size / 2;
    },
    radius() {
      return (this.size - this.strokeWidth) / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    clampedPercent() {
      return Math.max(0, Math.min(100, this.percent));
    },
    displayPercent() {
      return Math.round(this.clampedPercent);
    },
    dashOffset() {
      return this.circumference * (1 - this.clampedPercent / 100);
    },
  },
};
</script>

<style scoped>
.progress-ring {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.progress-ring-track {
  stroke: #ECEFF1;
}

.progress-ring-fill {
  transition: stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.progress-ring-label {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.progress-ring-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #263238;
}

.progress-ring-pct {
  font-size: 0.8em;
  font-weight: 600;
  color: #78909C;
}

.progress-ring-sublabel {
  font-size: 0.7rem;
  color: #90A4AE;
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>
